import { useMutation } from 'react-query';
import http from '../http';

// to create fave pass via merchant connect
const updateFavePassViaMerchantConnect = ({
  mc_product,
  fave_pass_id,
}: UpdateFavePassPayload) =>
  http.put<UpdateFavePassPayload>(
    `/v1/mc_products/${fave_pass_id}`,
    mc_product,
  );

export const useUpdateFavePassViaMerchantConnect = () =>
  useMutation(updateFavePassViaMerchantConnect);

export type UpdateFavePassPayload = {
  mc_product: FormData;
  fave_pass_id: string;
};
